<template>
  <div class="user-subscription-wrapper">
    <form class="user-subscription" @submit.prevent="submit">
      <div class="user-subscription-title">{{greetings}}</div>
      <div class="user-subscription-form">
        <input
          class="user-subscription-form-input"
          v-model="firstName"
          :placeholder="$t('FirstName')"
          required
        />
        <input
          class="user-subscription-form-input"
          v-model="lastName"
          :placeholder="$t('LastName')"
          required
        />
        <button
          type="submit"
          :style="{background: colors.primary, color: colors.text}"
          class="user-subscription-form-button-submit"
        >{{$t('GetStarted')}}</button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  name: 'UserSubscription',
  data() {
    return {
      firstName: "",
      lastName: "",
    };
  },
  props: {
    colors: {
      type: Object,
      required: true
    },
    greetings: {
      type: String,
      required: true
    }
  },
  methods: {
    submit() {
      this.$emit('submit', {
        first_name: this.firstName,
        last_name: this.lastName
      }, true)
    }
  }
};
</script>

<style>
.loading-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.user-subscription-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  text-align: center;
}

.user-subscription {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.user-subscription-title {
  margin: 2rem;
}
.user-subscription-form-input {
  border: 0;
  background-color: #eeeeee;
  outline: 0;
  padding: 1rem;
  border-radius: 10px;
  margin: 1rem;
  width: 70%;
}
.user-subscription-form-button-submit {
  display: block;
  border-radius: 10px;
  border: 0;
  width: 50%;
  margin: 2rem auto;
  padding: 1rem;
  cursor: pointer;
}
</style>
